import React, { useState } from "react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

const Application = () => {
    const [applications, setApplications] = useState([
        // Пример заявок
        { id: 1, name: "Application 1" },
        { id: 2, name: "Application 2" },
        { id: 3, name: "Application 3" },
        { id: 4, name: "Application 4" },
        { id: 5, name: "Application 5" },
        { id: 6, name: "Application 6" },
        { id: 7, name: "Application 7" },
        { id: 8, name: "Application 8" },
        { id: 9, name: "Application 9" },
        { id: 10, name: "Application 10" },
        { id: 11, name: "Application 11" },
        { id: 12, name: "Application 12" },
        { id: 13, name: "Application 13" },
        { id: 14, name: "Application 14" },
        { id: 15, name: "Application 15" },
        // Добавьте больше заявок по необходимости
    ]);
    const [currentPage, setCurrentPage] = useState(1);
    const applicationsPerPage = 10;
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [formData, setFormData] = useState({
        selectOption: "",
        description: ""
    });
    const [options, setOptions] = useState([
        { value: '1', label: 'Опция 1' },
        { value: '2', label: 'Опция 2' },
        { value: '3', label: 'Опция 3' },
        // Добавьте больше опций по необходимости
    ]);
    const [filteredOptions, setFilteredOptions] = useState([]);

    // Вычисляем текущие заявки для отображения
    const indexOfLastApplication = currentPage * applicationsPerPage;
    const indexOfFirstApplication = indexOfLastApplication - applicationsPerPage;
    const currentApplications = applications.slice(indexOfFirstApplication, indexOfLastApplication);

    // Смена страницы
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Переключение формы
    const toggleForm = () => setIsFormOpen(!isFormOpen);

    // Обработка изменения данных формы
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Обработка изменения данных поиска
    const handleSearchChange = (e) => {
        const inputValue = e.target.value.toLowerCase();
        setFilteredOptions(options.filter(option => option.label.toLowerCase().includes(inputValue)));
    };

    // Обработка выбора опции
    const handleOptionSelect = (option) => {
        setFormData({ ...formData, selectOption: option.value });
        setFilteredOptions([]);
    };

    return (
        <Layout>
            <div className="application">
                <div className="container">
                    <button className="application__add" onClick={toggleForm}>
                        Создать заявку {isFormOpen ? "▲" : "▼"}
                    </button>
                    <Link className="application__management" to='management' >Управление</Link>
                    {isFormOpen && (
                        <div className="application__form">
                            <input
                                type="text"
                                className="application__form-select"
                                placeholder="Поиск..."
                                onChange={handleSearchChange}
                            />
                            {filteredOptions.length > 0 && (
                                <ul className="application__form-options">
                                    {filteredOptions.map(option => (
                                        <li
                                            key={option.value}
                                            className="application__form-option"
                                            onClick={() => handleOptionSelect(option)}
                                        >
                                            {option.label}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <textarea
                                className="application__form-input"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="Описание"
                            />
                            <button className="application__form-submit">Добавить</button>
                        </div>
                    )}
                    <ul className="application-list">
                        {currentApplications.map((application) => (
                            <li className="application-list__item" key={application.id}>{application.name}</li>
                        ))}
                    </ul>
                    <div className="application-pagination">
                        {Array.from({ length: Math.ceil(applications.length / applicationsPerPage) }, (_, index) => (
                            <button className="application-pagination__button" key={index + 1} onClick={() => paginate(index + 1)}>
                                {index + 1}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Application;